import React from 'react';
import BroadcastComposer from './BroadcastComposer';

// One-off email to a set of agents (org admins to their org; system admin to a
// whole MLS). Transient — nothing is saved. subtitle/emptyMsg can be overridden
// so the same component reads correctly at the org and MLS levels.
function MessageAgents({ agents = [], orgName, fileKeys, subtitle, emptyMsg, signature = '' }) {
  const recipients = agents.map(a => {
    const name = a.alias || a.username;
    return { id: a.username, name, email: a.email, subs: { '{{Agent}}': name } };
  });
  return (
    <BroadcastComposer
      title="Message Agents"
      subtitle={subtitle || "Send a one-off email to agents in your organization. This isn't saved as a reminder — it sends now and is done."}
      recipients={recipients}
      variables={[{ key: '{{Agent}}', label: 'Agent' }]}
      fileKeys={fileKeys}
      defaultSubject={`A message from ${orgName || 'your team'}`}
      recipientNoun="agent"
      emptyMsg={emptyMsg || "No agents in your organization yet. Add them on the Agents tab."}
      signature={signature}
    />
  );
}

export default MessageAgents;
